<template>
  <div>
    <component
      :disabledOverride="disabled"
      :entity="attributeMap"
      :entityName="entityName"
      :is="configMap.elementType"
      :fkName="configMap.fkName"
      :placeholder="placeholder"
      :ruleList="ruleList"
      :valueNo="configMap.valueNo"
      :valueYes="configMap.valueYes"
      @change="
        entity => $set(attributeMap, 'valueDefault', entity.valueDefault)
      "
      attributeName="valueDefault"
      idAttributeName="userId"
      :attribute="configMap"
      v-if="allowDefaultValue"
    ></component>
    <template v-else>
      <p>Default values are not allowed for organization-specific items!</p>
    </template>
  </div>
</template>

<script>
import * as userComponentMap from "@/views/build/user/components/static";
import formElementMixin from "./formElementMixin";

export default {
  components: {
    ...userComponentMap,
  },
  computed: {
    itemList() {
      return this.$store.state["entity"].list;
    },
    item() {
      if (
        !this.attributeMap ||
        !this.attributeMap.fkExists ||
        !this.attributeMap.fkName
      ) {
        return;
      }
      const id = this.attributeMap.fkName;
      return this.$store.getters[`entity/getById`](id);
    },
    allowDefaultValue() {
      //clear default value whenever this changes
      if (!this.item || !this.attributeMap.fkExists) {
        return true;
      }
      return !this.item.isOrgSpecific;
    },
  },
  async created() {
    await this.$store.dispatch(`entity/list`, {
      reload: false,
    });
  },
  methods: {
    watcherClear(watcherOldVal) {
      if (!watcherOldVal) {
        return;
      }
      this.value = null;
    },
  },
  mixins: [formElementMixin],
  props: {
    configMap: {
      required: true,
    },
    counter: {},
    hint: {},
    optionConfig: {},
    placeholder: {},
    rules: {},
    entityName: {},
  },
  watch: {
    item(newVal, oldVal) {
      this.watcherClear(oldVal);
    },
    "attributeMap.fkExists"(newVal, oldVal) {
      this.watcherClear(oldVal);
    },
    "attributeMap.fkName"(newVal, oldVal) {
      this.watcherClear(oldVal);
    },
    "attributeMap.fkType"(newVal, oldVal) {
      this.watcherClear(oldVal);
    },
    "attributeMap.fkTypeValue"(newVal, oldVal) {
      this.watcherClear(oldVal);
    },
  },
};
</script>
